import { type DescMethod, type DescService, type Message, type MessageShape } from '@bufbuild/protobuf';
import { type QueryOptions } from '@connectrpc/connect-query';
import { type NoExtraProperties } from '@/utils/types';
import { type MessageInput } from './types';

type MessageInit<T extends Message> = {
  [K in keyof T as K extends `$unknown` ? never : K]: K extends '$typeName' ? never : T[K];
};

type OnlyTypeName = {
  readonly $typeName: never;
} & Record<string, never>;

type QueryMethodImpl<
  T extends DescMethod,
  TParams extends Message = MessageInit<MessageShape<T['input']>>,
> = TParams extends OnlyTypeName
  ? () => QueryOptions<T['output']>
  : (params: MessageInput<TParams>) => QueryOptions<T['output']>;

type QueryServiceImpl<Desc extends DescService> = {
  [P in keyof Desc['method'] as `${string & P}Query`]: QueryMethodImpl<Desc['method'][P]>;
};

export const createServiceQueries = <TService extends DescService, TImpl extends Partial<QueryServiceImpl<TService>>>(
  _service: TService,
  implementation: NoExtraProperties<TImpl, QueryServiceImpl<TService>>,
): TImpl => implementation;
